import request from '../../axios';

const PatchFarmRequirement = async (
  payload: IFarmRequirementPayload,
  guid?: string,
) => {
  const newPayload = {
    title: payload.title,
    sub_input: payload.sub_input?.guid,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    il_type: payload.type || undefined,
    brs_type: payload?.srs_type?.type,
    area: payload.area,
    area_unit: payload.area_unit?.value,
    only_massage_buyer: payload.only_massage_buyer || false,
    renting_duration: Number(payload.renting_duration),
    renting_duration_unit: payload.renting_duration_unit?.value,
    is_change_title: payload?.is_change_title,
    filter: 'requirement',
  };
  const response = await request.patch(`api/v2/store/advertisement/${guid}`, {
    ...newPayload,
  });

  return response.data;
};

export default PatchFarmRequirement;
